// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import CreateClaimModal, {getDefaultState as getCreateClaimModalState} from '../../../shared/state/create-claim-modal';
import Customer, {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import Modal, {getDefaultState as getModalDefaultState} from '../../shared/state/modal';
import ProductSearchResult, {getDefaultState as getProductSearchResultDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import Products, {getDefaultState as getProductsDefaultState} from './products';
import SearchFilters from '../../../shared/state/search-filters';
import {getDefaultState as getSearchFiltersDefaultState} from './search-filters';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    createClaimModal: CreateClaimModal,
    customer: Customer,
    isCustomerEditModalOpen: t.Boolean,
    isCustomerSearchModalOpen: t.Boolean,
    partialData: t.Boolean,
    product: ProductSearchResult,
    products: Products,
    searchFilters: SearchFilters,
    statusChangeModal: Modal
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        createClaimModal: getCreateClaimModalState(),
        customer: getCustomerDefaultState(),
        isCustomerEditModalOpen: false,
        isCustomerSearchModalOpen: false,
        partialData: false,
        product: getProductSearchResultDefaultState(),
        products: getProductsDefaultState(),
        searchFilters: getSearchFiltersDefaultState(),
        statusChangeModal: getModalDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/product/products-by-customer/state/index.js